const STATUS_CLASSES = new Set(['proposed', 'confirmed', 'active', 'rejected', 'expired', 'deleted']);

function createMemoryElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createState(message, error = '', retry = false) {
  const state = createMemoryElement('div', 'aichat-artifact-empty', error ? `${message}：${error}` : message);
  if (retry) {
    const button = createMemoryElement('button', '', '重新加载');
    button.type = 'button';
    button.dataset.memoryAction = 'reload';
    state.append(button);
  }
  return state;
}

function actionsFor(status) {
  if (status === 'proposed') return [['confirmed', '确认'], ['rejected', '拒绝']];
  if (status === 'confirmed' || status === 'active') return [['expired', '设为过期'], ['deleted', '删除']];
  if (status === 'expired' || status === 'rejected') return [['active', '恢复使用'], ['deleted', '删除']];
  return [];
}

export function renderMemoryList(root, { items = [], loading = false, error = '', getStatusLabel, getTypeLabel, formatTime } = {}) {
  if (!root) return;
  if (loading) return void root.replaceChildren(createState('正在同步你的偏好…'));
  if (error) return void root.replaceChildren(createState('记忆加载失败', error, true));
  if (!items.length) return void root.replaceChildren(createState('暂时没有需要长期记住的信息。直接在对话中说“记住……”即可。'));
  const intro = createMemoryElement('div', 'aichat-memory-intro', '这里仅保存会跨会话复用的偏好、目标和约束。调研报告、商品分析等资料会自动放到「素材」里，你无需管理上下文；当前输入和实时工具结果始终优先。');
  const cards = items.map((item) => {
    const status = STATUS_CLASSES.has(item.status) ? item.status : 'unknown';
    const card = createMemoryElement('article', `aichat-memory-card aichat-memory-card--${status}`);
    const header = document.createElement('header');
    header.append(createMemoryElement('span', '', getTypeLabel(item.memoryType)), createMemoryElement('strong', '', getStatusLabel(item.status)));
    const details = `来源：${item.sourceType || '未知'} · 记录：${formatTime(item.observedAt || item.createdAt)}${item.expiresAt ? ` · 到期：${formatTime(item.expiresAt)}` : ' · 到期：未设置'}`;
    card.append(header, createMemoryElement('p', '', item.summary || ''), createMemoryElement('small', '', details));
    const actions = actionsFor(item.status);
    if (actions.length) {
      const footer = document.createElement('footer');
      actions.forEach(([action, label]) => {
        const button = createMemoryElement('button', '', label);
        button.type = 'button';
        button.dataset.memoryAction = action;
        button.dataset.memoryId = item.id ?? '';
        footer.append(button);
      });
      card.append(footer);
    }
    return card;
  });
  root.replaceChildren(intro, ...cards);
}
